import UniqueId from "@/ts/base/Utils/UniqueId";

export default class Waypoint {

	static get InViewClass() {
		return "in-view";
	}

	static get LeftViewClass() {
		return "left-view";
	}

	static get DefaultThresholds(): number[] {
		return [0.25, 0.33, 0.5, 0.66, 0.75];
	}

	static get DefaultLeftViewThresholds(): number[] {
		return [0.0, 1.0];
	}

	protected waypointEls: NodeListOf<HTMLElement>;

	constructor(selector: NodeListOf<HTMLElement> | HTMLElement | string) {

		if (typeof selector === "string") {
			this.waypointEls = document.querySelectorAll(selector);
		}
		else if (selector instanceof HTMLElement) {
			if (selector.id === "") {
				selector.id = `Waypoint__${UniqueId()}`;
			}
			this.waypointEls = document.querySelectorAll(`#${selector.id}`);
		}
		else {
			this.waypointEls = selector;
		}

		if (this.waypointEls.length > 0) {
			this.createObserver();
		}
	}

	protected getCommaSeparatedDataset(name: string, waypoint: HTMLElement): number[] {
		let out: number[] = [];
		const items: string[] = waypoint.dataset[name] ? String(waypoint.dataset[name]).split(",") : [];

		items.forEach(num => {
			out.push(Number.parseFloat(num));
		});

		return out;
	}

	protected getWaypointThresholds(waypoint: HTMLElement): number[] {
		const out = this.getCommaSeparatedDataset("threshold", waypoint);
		if (out.length == 0) {
			return Waypoint.DefaultThresholds;
		}
		return out;
	}

	protected getWaypointLeftViewThresholds(waypoint: HTMLElement): number[] {
		const out = this.getCommaSeparatedDataset("leftViewThreshold", waypoint);
		if (out.length == 0) {
			return Waypoint.DefaultLeftViewThresholds;
		}
		return out;
	}

	protected createObserver(): void {
		const observer = new IntersectionObserver(this.onObserve.bind(this), <IntersectionObserverInit>{
			threshold: Waypoint.DefaultThresholds
		});

		this.waypointEls.forEach(i => {
			observer.observe(i);
		});
	}

	checkWaypoint(waypoint: HTMLElement, entry: IntersectionObserverEntry, observer: IntersectionObserver): boolean {
		if (!waypoint) {
			return false;
		}

		const thresholds: number[] = this.getWaypointThresholds(waypoint);
		const leftViewThresholds: number[] = this.getWaypointLeftViewThresholds(waypoint);
		const isTriggerAlways = waypoint.dataset.triggerAlways != undefined;

		if (!isTriggerAlways) {
			if (entry.isIntersecting) {
				this.updateWaypoint(waypoint, true);
				observer.unobserve(waypoint);
			}
		}
		else {
			if (entry.isIntersecting) {
				this.updateWaypoint(waypoint, true);
			}
			else {
				this.updateWaypoint(waypoint, false);
			}
		}

		return entry.isIntersecting;
	}

	updateWaypoint(waypoint: HTMLElement, isInView: boolean): void {
		const isTriggerAlways = waypoint.dataset.triggerAlways != undefined;

		if (isInView) {
			waypoint.classList.add(Waypoint.InViewClass);
			waypoint.dispatchEvent(new Event(Waypoint.InViewClass));
			if (!isTriggerAlways) {
				waypoint.classList.add("triggered");
			}
		}
		else {
			waypoint.classList.remove(Waypoint.InViewClass);
			waypoint.classList.add(Waypoint.LeftViewClass);
		}
	}


	protected onObserve(entries: IntersectionObserverEntry[], observer: IntersectionObserver): void {
		entries.forEach(entry => {
			this.checkWaypoint(entry.target as HTMLElement, entry, observer);
		});
	}
}
